import { useParams, useSearchParams } from 'react-router-dom';
import { KlantDetailView } from '../components/klanten/KlantDetailView';

export function KlantDetailPage() {
  const { customerId } = useParams<{ customerId: string }>();
  const [searchParams] = useSearchParams();
  const type = (searchParams.get('type') || 'account') as 'account' | 'lead';

  if (!customerId) {
    return (
      <>
        <div className="flex-1 flex items-center justify-center text-slate-400">
          <p className="text-sm">Geen klant geselecteerd</p>
        </div>
      </>
    );
  }

  return (
    <>
      <KlantDetailView customerId={customerId} type={type} variant="page" />
    </>
  );
}
